import { PEOPLE_COLUMNS_ORDERED } from 'emma-common-ts/emma';

const PEOPLE_COLUMNS_I18N = {
  [PEOPLE_COLUMNS_ORDERED.ID]: $localize`ID`,
  [PEOPLE_COLUMNS_ORDERED.CUSTOMER_ID]: $localize`ID de cliente`,
  [PEOPLE_COLUMNS_ORDERED.EMAIL]: $localize`Email`,
  [PEOPLE_COLUMNS_ORDERED.DEVICE_ID]: $localize`ID de dispositivo`,
  [PEOPLE_COLUMNS_ORDERED.DEVICE]: $localize`Dispositivo`,
  [PEOPLE_COLUMNS_ORDERED.DEVICE_ID_TYPE]: $localize`Tipo de ID de dispositivo`,
  [PEOPLE_COLUMNS_ORDERED.OS]: $localize`Sistema operativo`,
  [PEOPLE_COLUMNS_ORDERED.OS_VERSION]: $localize`Versión del SO`,
  [PEOPLE_COLUMNS_ORDERED.IP]: $localize`IP`,
  [PEOPLE_COLUMNS_ORDERED.CARRIER]: $localize`Operador`,
  [PEOPLE_COLUMNS_ORDERED.ACCEPT_LANGUAGE]: $localize`Idioma aceptado`,
  [PEOPLE_COLUMNS_ORDERED.CONNECTION_TYPE]: $localize`Tipo de conexión`,
  [PEOPLE_COLUMNS_ORDERED.APP_VERSION]: $localize`Versión de la aplicación`,
  [PEOPLE_COLUMNS_ORDERED.EMMA_BUILD]: $localize`Versión de EMMA`,
  [PEOPLE_COLUMNS_ORDERED.INSTALL_AT]: $localize`Instalado el`,
  [PEOPLE_COLUMNS_ORDERED.UPDATED_AT]: $localize`Actualizado el`,
  [PEOPLE_COLUMNS_ORDERED.REGISTERED_AT]: $localize`Registrado el`,
  [PEOPLE_COLUMNS_ORDERED.FIRST_LOGIN]: $localize`Primer inicio de sesión`,
  [PEOPLE_COLUMNS_ORDERED.LAST_LOGIN]: $localize`Último inicio de sesión`,
  [PEOPLE_COLUMNS_ORDERED.LOYAL_USER_AT]: $localize`Usuario leal el`,
  [PEOPLE_COLUMNS_ORDERED.LOYAL_BUYER_AT]: $localize`Comprador leal el`,
  [PEOPLE_COLUMNS_ORDERED.LAST_SESSION_AT]: $localize`Última sesión el`,
  [PEOPLE_COLUMNS_ORDERED.CONVERSIONS]: $localize`Ventas`,
  [PEOPLE_COLUMNS_ORDERED.LAST_CONVERSION_AT]: $localize`Última venta el`,
  [PEOPLE_COLUMNS_ORDERED.FIRST_CONVERSION_AT]: $localize`Primera venta el`,
  [PEOPLE_COLUMNS_ORDERED.SECONDS_TO_FIRST_CONVERSION]: $localize`Segundos hasta la primera venta`,
  [PEOPLE_COLUMNS_ORDERED.LATITUDE]: $localize`Latitud`,
  [PEOPLE_COLUMNS_ORDERED.LONGITUDE]: $localize`Longitud`,
  [PEOPLE_COLUMNS_ORDERED.CITY]: $localize`Ciudad`,
  [PEOPLE_COLUMNS_ORDERED.STATE]: $localize`Provincia`,
  [PEOPLE_COLUMNS_ORDERED.COUNTRY]: $localize`País`,
  [PEOPLE_COLUMNS_ORDERED.INACTIVE]: $localize`Inactivo`,
  [PEOPLE_COLUMNS_ORDERED.REFERRER_ID]: $localize`ID de Referrer`,
  [PEOPLE_COLUMNS_ORDERED.FROM_CAMPAIGN]: $localize`De la campaña`,
  [PEOPLE_COLUMNS_ORDERED.FROM_SOURCE]: $localize`De la fuente`,
};

export const getPeopleColumnsI18n = (columnName: PEOPLE_COLUMNS_ORDERED): string => {
  return PEOPLE_COLUMNS_I18N[columnName] ?? columnName;
};
